import { DateTime, P } from '@piccolohealth/util';
import React from 'react';
import { ChakraV3 } from '..';

interface Props extends ChakraV3.StackProps {
  date: DateTime;
  format?: 'SHORT' | 'LONG' | Intl.DateTimeFormatOptions;
  direction?: ChakraV3.StackProps['direction'];
  showHumanized?: boolean;
  showTooltip?: boolean;
  tooltip?: () => React.ReactNode;
}

const getFormat = (format: Props['format']): Intl.DateTimeFormatOptions => {
  if (!P.isString(format) && !P.isNil(format)) {
    return format;
  }

  switch (format) {
    case 'SHORT':
      return DateTime.DATETIME_SHORT;
    case 'LONG':
      return DateTime.DATETIME_FULL;
    default:
      return DateTime.DATETIME_SHORT;
  }
};

export const FancyDate = (props: Props) => {
  const { date, format, direction, showHumanized, showTooltip, tooltip, ...rest } = props;
  const datePrime = DateTime.fromISO(date.toString());
  const absolute = datePrime.toLocaleString(getFormat(format));
  const timestamp = datePrime.toLocaleString(getFormat('LONG'));

  return (
    <ChakraV3.Stack gap={1} align='start' direction={direction} {...rest}>
      <ChakraV3.Tooltip
        content={tooltip ? tooltip() : <ChakraV3.Text>{timestamp}</ChakraV3.Text>}
        disabled={!(showTooltip ?? true)}
      >
        <ChakraV3.Text>{absolute}</ChakraV3.Text>
      </ChakraV3.Tooltip>
      {(showHumanized ?? true) && (
        <ChakraV3.Text color='secondary'>{datePrime.toRelative()}</ChakraV3.Text>
      )}
    </ChakraV3.Stack>
  );
};
